/**
 * Pets Domain – Click & Collect strict radio gate + Tasmania Home Delivery
 *
 * CLICK & COLLECT (Store Pickup)
 *  - checkout locked until an outlet radio is selected
 *  - sets cart attributes:
 *      cnc-fulfilment-method = "store"
 *      cnc-outlet           = <outlet id>
 *      rex_outlet_id        = <outlet id>
 *      cnc-postcode         = ""
 *
 * TASMANIA HOME DELIVERY
 *  - button: #rex-cnc-delivery
 *  - shows postcode input + Check button
 *  - only allows TAS postcodes:
 *      7000-7019,7050-7108,7172,7248-7254,7258,7259-7329,7800-7999
 *  - blocked if any cart item has tag "DeliveryUnavailable"
 *  - sets cart attributes:
 *      cnc-fulfilment-method = "home"
 *      cnc-postcode          = <postcode>
 *      cnc-outlet            = ""
 *      rex_outlet_id         = ""
 *
 * SLOW INTERNET / VENDOR PROTECTION
 *  - checkout buttons disabled until allowCheckout=true
 *  - body gets .pd-allow when allowed (CSS reveals checkout)
 *  - capturing click listener blocks ALL checkout attempts
 *  - vendor shim mirrors disabled state across buttons
 */

(function PD_CNC_StrictGate_TAS() {
  'use strict';

  // Cart page only
  const onCart =
    document.body.classList.contains('template-cart') ||
    /\/cart(\/|$|\?)/.test(location.pathname) ||
    !!document.querySelector('form[action="/cart"]');
  if (!onCart) return;

  // ---------- selectors ----------
  const SEL = {
    cartForm: 'form.form-cart, form[action="/cart"]',
    checkoutButtons: 'button[name="checkout"]',
    expressContainer: '.additional-checkout-buttons, .overlay-buy_button',

    pickupToggle:   '#rex-cnc-pickup',
    deliveryToggle: '#rex-cnc-delivery',

    results:     '#rex-cnc-results',
    searchWrap:  '#rex-cnc-search',
    mapWrap:     '#rex-cnc-map',
    searchBtn:   '#rex-cnc-searchbutton',
    searchInput: '#rex-cnc-searchinput',
    spinner:     '#rex-store-loading',
    outletRadio: 'input[name="outlet"]',
    outletItem:  '.rex-cnc-outlet',

    // Home delivery UI (we inject this)
    deliveryWrap:  '#rex-delivery-wrap',
    deliveryInput: '#rex-delivery-postcode',
    deliveryBtn:   '#rex-delivery-check',
    deliveryMsg:   '#rex-delivery-msg',

    // ignore discount tab forms
    discountArea: '.accordion-a'
  };

  // ---------- helpers ----------
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  // ---------- spinner (shared) ----------
  let spinnerTimer = null;
  function showSpinner() {
    const sp = $(SEL.spinner);
    if (!sp) return;
    sp.style.display = 'flex';
    clearTimeout(spinnerTimer);
    spinnerTimer = setTimeout(() => {
      sp.style.display = 'none';
      spinnerTimer = null;
    }, 8000);
  }
  function hideSpinner() {
    const sp = $(SEL.spinner);
    if (!sp) return;
    sp.style.display = 'none';
    clearTimeout(spinnerTimer);
    spinnerTimer = null;
  }

  // ---------- TAS home delivery postcode ranges ----------
  //const ALLOWED_SPEC = '7000-7019,7050-7053,7055-7108,7172,7248-7254,7258-7329,7800-7999';
const ALLOWED_SPEC = '200-299,1000-1935,1936-1999,2000-2079,2080-2084,2085-2107,2108,2109-2156,2157,2158,2159,2160-2172,2173,2174-2229,2230-2231,2232-2249,2250-2263,2282-2310,2485-2486,2500-2507,2508-2514,2515-2532,2555-2556,2557-2559,2560-2563,2564-2567,2568-2574,2600-2620,2640-2641,2708-2709,2740-2744,2745-2746,2747-2751,2752-2758,2759-2764,2765,2766-2774,2775,2776-2777,2778-2786,2890-2897,2900-2920,3000-3062,3063,3064-3098,3099-3100,3101-3138,3139,3140-3210,3211-3220,3335-3341,3350,3353-3356,3427-3443,3689-3690,3750-3799,3800-3801,3802-3811,3910-3920,3926-3944,3975-3978,3980-3983,4000-4018,4019-4028,4029-4068,4069-4071,4072-4123,4124-4126,4127-4129,4130,4131-4132,4133-4150,4151-4164,4165-4168,4169-4182,4183-4204,4205-4206,4207-4209,4210-4224,4225,4226-4269,4270-4299,4300-4308,4500-4549,4550-4579,5000-5113,5114,5115-5117,5118-5124,5125-5130,5131-5157,5158-5169,5170-5200,5800-5999,7000-7019,7020-7026,7030,7050-7053,7055-7108,7170-7171,7172,7173-7174,7210-7213,7248-7254,7258-7329,7800-7999,8000-8999,9000-9725,9726-9919,9999';
  function parseSpec(spec) {
    const parts = (spec || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);

    const ranges = [];
    const singles = {};

    parts.forEach(p => {
      if (p.includes('-')) {
        const [a, b] = p.split('-');
        const n1 = parseInt(a, 10);
        const n2 = parseInt(b, 10);
        if (!isNaN(n1) && !isNaN(n2)) {
          ranges.push([Math.min(n1, n2), Math.max(n1, n2)]);
        }
      } else {
        const n = parseInt(p, 10);
        if (!isNaN(n)) singles[n] = true;
      }
    });

    return { ranges, singles };
  }

  const ALLOWED = parseSpec(ALLOWED_SPEC);

  function isPostcodeAllowed(pc) {
    const n = parseInt(String(pc || '').trim(), 10);
    if (isNaN(n)) return false;
    if (ALLOWED.singles[n]) return true;
    for (let i = 0; i < ALLOWED.ranges.length; i++) {
      const [a, b] = ALLOWED.ranges[i];
      if (n >= a && n <= b) return true;
    }
    return false;
  }

  // ---------- global state ----------
  let allowCheckout    = false;  // master gate
  let deliveryOk       = false;  // home delivery valid?
  let deliveryPostcode = '';
  let currentMode      = null;   // null | 'pickup' | 'delivery'

  // ---------- cart attribute helpers ----------
  function updateCartAttributes(attrs) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ attributes: attrs })
      }).catch(() => { /* silent */ });
    } catch (e) {
      // ignore
    }
  }

  // Store pickup attributes
  function setOutletAttributes(outletId) {
    const id = (outletId || '').toString().trim();
    const attrs = id
      ? {
          'cnc-fulfilment-method': 'store',
          'cnc-outlet':           id,
          'rex_outlet_id':        id,
          'cnc-postcode':         ''
        }
      : {
          'cnc-fulfilment-method': 'store',
          'cnc-outlet':           '',
          'rex_outlet_id':        '',
          'cnc-postcode':         ''
        };
    updateCartAttributes(attrs);

      // NEW: tell backend that this cart is Click & Collect
    setFulfilmentLineProperty('store');
  }

    // ---------- fulfilment mode → line item property (for carrier service) ----------
  // We store mode on the FIRST line item as: _fulfilment_mode = "store" | "home"
  function setFulfilmentLineProperty(mode) {
    const value = mode === 'home' ? 'home' : 'store';

    try {
      fetch('/cart.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(r => r.json())
        .then(cart => {
          if (!cart || !cart.items || !cart.items.length) return;

          const line = cart.items[0]; // we only need one line to carry the flag
          const props = Object.assign({}, line.properties || {}, {
            _fulfilment_mode: value
          });

          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: line.key,
              quantity: line.quantity,
              properties: props
            })
          });
        })
        .catch(() => { /* silent */ });
    } catch (e) {
      // ignore
    }
  }


  // Home delivery attributes
  function setDeliveryAttributes(pc) {
    const val = (pc || '').toString().trim();
    const attrs = val
      ? {
          'cnc-fulfilment-method': 'home',
          'cnc-postcode':         val,
          'cnc-outlet':           '',
          'rex_outlet_id':        ''
        }
      : {
          'cnc-fulfilment-method': 'home',
          'cnc-postcode':         '',
          'cnc-outlet':           '',
          'rex_outlet_id':        ''
        };
    updateCartAttributes(attrs);

    // NEW: tell backend that this cart is Click & Collect
    setFulfilmentLineProperty('home');
  }

  // ---------- checkout gate ----------
  function syncCheckoutUi() {
    if (allowCheckout) {
      document.body.classList.add('pd-allow');  // CSS reveals checkout
      $$(SEL.checkoutButtons).forEach(b => {
        b.classList.remove('pd-disabled');
        b.disabled = false;
        b.removeAttribute('aria-disabled');
      });
      const express = $(SEL.expressContainer);
      if (express) express.style.display = '';
      const sg = document.getElementById('rex-server-guard');
      if (sg && sg.parentNode) sg.parentNode.removeChild(sg);
    } else {
      document.body.classList.remove('pd-allow');
      $$(SEL.checkoutButtons).forEach(b => {
        b.classList.add('pd-disabled');
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
      });
      const express = $(SEL.expressContainer);
      if (express) express.style.display = 'none';
    }
  }

function recomputeGate() {
  const checkedOutlet = $(SEL.outletRadio + ':checked');

  // Only count pickup if we are actually in pickup mode
  const pickupOk   = currentMode === 'pickup'   && !!checkedOutlet;
  // Only count delivery if we are in delivery mode AND a valid postcode is confirmed
  const deliveryOK = currentMode === 'delivery' && deliveryOk;

  allowCheckout = !!(pickupOk || deliveryOK);
  syncCheckoutUi();

  // --- keep attributes aligned with the mode ---

  // If we’re in pickup mode and a store is selected, make sure attrs are "store" + outlet IDs
  if (pickupOk && checkedOutlet) {
    setOutletAttributes(String(checkedOutlet.value || '').trim());
  }

  // If we’re in delivery mode, make sure attrs are "home" with correct postcode / cleared outlets
  if (currentMode === 'delivery') {
    if (deliveryOk && deliveryPostcode) {
      // valid postcode already checked
      setDeliveryAttributes(deliveryPostcode);
    } else {
      // no valid postcode yet – still home mode but with empty postcode/outlets
      setDeliveryAttributes('');
    }
  }
}


  // ---------- DeliveryUnavailable guard ----------
  // Returns Promise<boolean> -> true if any cart item has tag "deliveryunavailable"
  function cartHasDeliveryUnavailable() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        if (!cart || !cart.items || !cart.items.length) return false;

        const reqs = [];

        for (let i = 0; i < cart.items.length; i++) {
          const it = cart.items[i];
          if (!it) continue;

          let handle = it.handle;
          if (!handle && it.url && it.url.indexOf('/products/') !== -1) {
            handle = it.url.split('/products/')[1].split('?')[0];
          }
          if (!handle) continue;

          const req = fetch('/products/' + encodeURIComponent(handle) + '.js', {
            credentials: 'same-origin'
          })
            .then(r => r.json())
            .then(prod => {
              let tags = (prod && prod.tags) || [];
              if (typeof tags === 'string') {
                tags = tags
                  .split(',')
                  .map(s => s.trim())
                  .filter(Boolean);
              }
              for (let t = 0; t < tags.length; t++) {
                if (String(tags[t]).toLowerCase() === 'deliveryunavailable') {
                  return true;
                }
              }
              return false;
            })
            .catch(() => false);

          reqs.push(req);
        }

        if (!reqs.length) return false;

        return Promise.all(reqs).then(list => {
          for (let k = 0; k < list.length; k++) {
            if (list[k]) return true;
          }
          return false;
        });
      })
      .catch(() => false);
  }

  // ---------- home delivery UI helpers ----------
  function ensureDeliveryUi() {
    if ($(SEL.deliveryWrap)) return;

    const buttonsRow = document.getElementById('rex-cnc-buttons');
    const wrap = document.createElement('div');
    wrap.id = 'rex-delivery-wrap';
    wrap.style.marginTop = '12px';
    wrap.style.display = 'none';

    wrap.innerHTML =
      '<div style="display:flex;gap:8px;align-items:center;max-width:520px;">' +
        '<input id="rex-delivery-postcode" inputmode="numeric" pattern="[0-9]*" ' +
          'class="field__input" ' +
          'placeholder="Enter postcode for home delivery" ' +
          'style="flex:1;min-width:0;font-size:16px;padding:10px 12px;" />' +
        '<button id="rex-delivery-check" type="button" class="button button--secondary" ' +
          'style="font-size:16px;font-weight:600;padding:10px 20px;min-width:110px;">' +
          'Check' +
        '</button>' +
      '</div>' +
      '<div id="rex-delivery-msg" style="margin-top:8px;font-size:16px;font-weight:600;"></div>';

    if (buttonsRow && buttonsRow.parentNode) {
      buttonsRow.parentNode.insertBefore(wrap, buttonsRow.nextSibling);
    } else {
      (document.getElementById('rex-cnc-container') || document.body).appendChild(wrap);
    }
  }

  function setDeliveryMessage(msg, ok) {
    const el = $(SEL.deliveryMsg);
    if (!el) return;
    el.textContent = msg || '';
    el.style.color = ok ? '#1b5e20' : '#b00020';
  }

  function handleDeliveryCheck() {
    const input = $(SEL.deliveryInput);
    if (!input) return;

    const val = (input.value || '').trim();

    // reset state + attributes
    deliveryOk = false;
    deliveryPostcode = '';
    setDeliveryAttributes('');

    if (!/^\d{4}$/.test(val)) {
      setDeliveryMessage('Please enter a valid 4-digit postcode.', false);
      recomputeGate();
      return;
    }

    if (!isPostcodeAllowed(val)) {
      setDeliveryMessage('Sorry, Home Delivery is unavailable for ' + val + '.', false);
      recomputeGate();
      return;
    }

    deliveryOk = true;
    deliveryPostcode = val;
    setDeliveryMessage('Great! Home Delivery is available for ' + val + '.', true);
    setDeliveryAttributes(val);
    recomputeGate();
  }

  // ---------- wire everything ----------
  function wire() {
    const results      = $(SEL.results);
    const searchWrap   = $(SEL.searchWrap);
    const mapWrap      = $(SEL.mapWrap);
    const pickupBtn    = $(SEL.pickupToggle);
    const deliveryBtn  = $(SEL.deliveryToggle);
    const searchBtn    = $(SEL.searchBtn);
    const searchInput  = $(SEL.searchInput);

    // Inject delivery UI
    ensureDeliveryUi();
    const deliveryWrap  = $(SEL.deliveryWrap);
    const deliveryInput = $(SEL.deliveryInput);
    const deliveryCheck = $(SEL.deliveryBtn);

    // Start STRICT: checkout locked until store OR delivery valid
    allowCheckout = false;
    deliveryOk = false;
    deliveryPostcode = '';
    currentMode = null;
    syncCheckoutUi();

    // Start with everything hidden until user chooses a mode
    if (searchWrap)   searchWrap.style.display   = 'none';
    if (mapWrap)      mapWrap.style.display      = 'none';
    if (results)      results.style.display      = 'none';
    if (deliveryWrap) deliveryWrap.style.display = 'none';

    // --- Mode handlers ---
  function openPickupPanels() {
  currentMode = 'pickup';

  // Show C&C widgets, hide delivery box
  if (deliveryWrap) deliveryWrap.style.display = 'none';
  if (searchWrap)   searchWrap.style.display   = 'block';
  if (mapWrap)      mapWrap.style.display      = 'block';
  if (results)      results.style.display      = 'block';

  // Clear delivery *state* only (don’t set fulfilment to "home" here)
  deliveryOk = false;
  deliveryPostcode = '';
  setDeliveryMessage('', true);

  recomputeGate();
}


    function openDeliveryPanels() {
      currentMode = 'delivery';

      // Hide C&C widgets, show delivery box
      if (searchWrap)   searchWrap.style.display   = 'none';
      if (mapWrap)      mapWrap.style.display      = 'none';
      if (results)      results.style.display      = 'none';
      if (deliveryWrap) deliveryWrap.style.display = 'block';

      // Require fresh postcode each time they swap modes
      deliveryOk = false;
      deliveryPostcode = '';
      setDeliveryMessage('', true);
      setDeliveryAttributes('');

      recomputeGate();
    }

    // Try to open delivery panels, but block if any DeliveryUnavailable item
    function tryOpenDeliveryPanels() {
      showSpinner();
      cartHasDeliveryUnavailable().then(blocked => {
        hideSpinner();
        if (blocked) {
          alert('Some items in your cart aren’t eligible for home delivery.');
          return;
        }
        openDeliveryPanels();
      });
    }

    // Pickup button (works alongside Rex handler)
    pickupBtn?.addEventListener('click', openPickupPanels);
    document.addEventListener('click', (e) => {
      if (e.target && e.target.closest && e.target.closest('#rex-cnc-pickup')) {
        openPickupPanels();
      }
    }, true);

    // Delivery button – now guarded by DeliveryUnavailable check
    deliveryBtn?.addEventListener('click', (e) => {
      e.stopImmediatePropagation?.(); // prevent vendor from switching panels first
      tryOpenDeliveryPanels();
    });
    document.addEventListener('click', (e) => {
      if (e.target && e.target.closest && e.target.closest('#rex-cnc-delivery')) {
        e.stopImmediatePropagation?.();
        tryOpenDeliveryPanels();
      }
    }, true);

    // Spinner for pickup search only when actual query is sent
    if (searchBtn && searchInput) {
      searchBtn.addEventListener('click', () => {
        if (searchInput.value && searchInput.value.trim() !== '') showSpinner();
      });
    }

    // Delivery postcode check
    if (deliveryCheck) {
      deliveryCheck.addEventListener('click', () => {
        showSpinner();
        setTimeout(() => {
          hideSpinner();
          handleDeliveryCheck();
        }, 150);
      });
    }
    if (deliveryInput) {
      deliveryInput.addEventListener('keyup', (ev) => {
        if (ev.key === 'Enter' || ev.keyCode === 13) {
          showSpinner();
          setTimeout(() => {
            hideSpinner();
            handleDeliveryCheck();
          }, 150);
        }
      });
    }

    // When user changes store selection (C&C)
    results?.addEventListener('change', (evt) => {
      const t = evt.target;
      if (t && t.matches && t.matches(SEL.outletRadio)) {
        // highlight selected outlet
        $$(SEL.outletItem).forEach(el => {
          el.style.backgroundColor = '#e3f2fd';
          el.style.border = '1px solid #90caf9';
          el.style.boxShadow = 'none';
          el.style.borderRadius = '6px';
        });
        const li = t.closest(SEL.outletItem);
        if (li) {
          li.style.backgroundColor = '#fff';
          li.style.border = '2px solid #1f9BDE';
          li.style.boxShadow = '0 0 10px rgba(31,155,222,.4)';
        }

        setOutletAttributes(String(t.value || '').trim());
        recomputeGate();
      }
    }, true);

    // If vendor re-renders outlet list, hide spinner & recompute
    if (results) {
      new MutationObserver((muts) => {
        if (muts.some(m => m.addedNodes.length || m.removedNodes.length)) {
          hideSpinner();
          recomputeGate(); // only enables if a radio is actually checked
        }
      }).observe(results, { childList: true, subtree: true });
    }

    // Gate all checkout attempts (buttons & links) – SLOW INTERNET SAFE
    document.addEventListener('click', (e) => {
      const btn  = e.target.closest?.('button[name="checkout"]');
      const link = e.target.closest?.('a[href*="/checkout"], a[href^="/cart/checkout"]');
      if (!btn && !link) return;

      // Ignore discount/giftcard submit buttons
      if (btn && btn.closest && btn.closest(SEL.discountArea)) return;

      if (!allowCheckout) {
        e.preventDefault();
        e.stopImmediatePropagation?.();
        alert(
          currentMode === 'delivery'
            ? 'Please enter a valid serviceable postcode to continue (Home Delivery).'
            : 'Please select a store to continue (Click & Collect).'
        );
        return;
      }

      // Allowed: ensure cart form includes "checkout" param (for safety)
      const form = (btn || link)?.closest(SEL.cartForm);
      if (form && btn) {
        let hidden = form.querySelector('input[type="hidden"][name="checkout"]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'checkout';
          hidden.value = 'Checkout';
          form.appendChild(hidden);
        }
        // Stop other handlers from hijacking click when valid
        e.stopPropagation();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire, { once: true });
  } else {
    wire();
  }
})();

/* ===== Vendor interop: ensure #checkout exists & mirror state (unchanged) ===== */
(() => {
  'use strict';
  if (window.__pdShimLoaded) return; window.__pdShimLoaded = true;

  function onBody(fn) {
    if (document.body) fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  onBody(() => {
    if (!document.getElementById('checkout')) {
      const first = document.querySelector('button[name="checkout"]');
      if (first) first.id = 'checkout';
    }

    function master() {
      return document.getElementById('checkout') ||
             document.querySelector('button[name="checkout"]');
    }

    function sync() {
      const m = master(); if (!m) return;
      const disabled = !!m.disabled || m.getAttribute('aria-disabled') === 'true';

      document.querySelectorAll('button[name="checkout"]').forEach(btn => {
        if (btn === m) return;
        if (!!btn.disabled !== disabled) btn.disabled = disabled;
        const aria = btn.getAttribute('aria-disabled') === 'true';
        if (aria !== disabled) {
          if (disabled) btn.setAttribute('aria-disabled','true');
          else btn.removeAttribute('aria-disabled');
        }
      });

      const express =
        document.querySelector('.additional-checkout-buttons') ||
        document.querySelector('.overlay-buy_button');
      if (express) {
        express.style.display = document.body.classList.contains('pd-allow') ? '' : 'none';
      }
    }

    window.addEventListener('load', sync, {once:true});
    new MutationObserver(muts => {
      if (muts.some(m => m.addedNodes.length || m.removedNodes.length)) sync();
    }).observe(document.body, {childList:true, subtree:true});
    document.addEventListener('click', sync, true);
  });
})();

/* ===== Google Places AU→NZ shim (unchanged) ===== */
(function rexFixAutocomplete(){
  'use strict';
  const MAX_WAIT_MS = 20000;
  const start = Date.now();
  function ready() {
    return !!(window.google &&
              google.maps &&
              google.maps.places &&
              google.maps.places.AutocompleteService);
  }
  function patch() {
    const S = google.maps.places.AutocompleteService;
    if (!S || S.prototype.__rexPatched) return;
    const orig = S.prototype.getPlacePredictions;
    S.prototype.getPlacePredictions = function(request, cb) {
      const base = Object.assign({}, request);
      let countries = ['AU','NZ'];
      const cr = base.componentRestrictions && base.componentRestrictions.country;
      if (typeof cr === 'string') countries = [cr.toUpperCase()];
      else if (Array.isArray(cr) && cr.length) {
        countries = cr.map(c => String(c).toUpperCase());
      }
      const baseTypes = ['(regions)'];
      const self = this;
      (function tryCountry(i){
        if (i >= countries.length) {
          cb([], google.maps.places.PlacesServiceStatus.ZERO_RESULTS);
          return;
        }
        const req = Object.assign({}, base, {
          componentRestrictions: { country: countries[i] },
          types: baseTypes
        });
        orig.call(self, req, (preds, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK && preds && preds.length) {
            cb(preds, status);
          } else {
            tryCountry(i + 1);
          }
        });
      })(0);
    };
    S.prototype.__rexPatched = true;
  }
  (function waitThenPatch(){
    if (ready()) return patch();
    if (Date.now() - start > MAX_WAIT_MS) return;
    setTimeout(waitThenPatch, 200);
  })();
})();
